import React from 'react';
import AlloyFinger from 'alloyfinger';
import PropTypes from 'prop-types';
import './slides.css';

export default class Slides extends React.Component {
  constructor(props) {
    super(props);
    this.initProps(props);
    this.initSlides(props);
    this.bindHanlders([
      'onSlideLeft',
      'onSlideRight',
      'onDotsClick',
      'onSwipe',
    ]);
    this.state = {
      key: 0,
      direction: 'left',
    };
  }

  initProps({ width = '600px', height = '400px', duration = 300 }) {
    console.log('initProps');
    const regex = /[0-9]+(px|%)$/;
    if (!regex.test(width) || !regex.test(height)) {
      throw TypeError('invalid width or height');
    }
    this.width = width;
    this.height = height;
    this.duration = `${duration}ms`;
  }

  initSlides({ children }) {
    console.log('initSlides');
    this.slides = children.map((slide, index) => {
      // console.log(slide, slide.props.style);
      const style = Object.assign({
        width: this.width,
        height: this.height,
        flexShrink: 0,
      }, slide.props.style);
      return React.cloneElement(slide, {
        style,
        key: index,
      });
    });
    this.head = React.cloneElement(this.slides[this.slides.length - 1], {
      key: this.slides.length,
      className: 'head',
    });
    this.tail = React.cloneElement(this.slides[0], {
      key: -1,
      className: 'tail',
    });
  }

  componentDidMount() {
    // console.log('componentDidMount');
    const { autoplay, delay = 1000 } = this.props;
    const loop = () => {
      // console.log('loop');
      this.onSlideRight();
      this.timeoutID = setTimeout(loop.bind(this), delay);
      // console.log('timeoutID', this.timeoutID);
    };
    if (autoplay) {
      // console.log('auto play');
      this.autoTimeoutID = setTimeout(loop.bind(this), delay);
      // console.log('autoTimeoutID', this.autoTimeoutID);
    }

    if (this.container) {
      new AlloyFinger(this.container, {
        swipe: this.onSwipe,
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    // console.log('componentWillUpdate');
    const { key, direction } = nextState;
    const skipToLastSlide = (
      direction === 'left' &&
      this.state.key === -1 &&
      key === this.slides.length - 1
    );
    const skipToFirstSlide = (
      key === 0 &&
      direction === 'right' &&
      this.state.key === this.slides.length
    );
    if (skipToFirstSlide || skipToLastSlide) {
      this.duration = '0s';
    } else {
      this.duration = `${this.props.duration}ms`;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('componentDidUpdate');
    const { key } = prevState;
    const { direction } = this.state;
    const slideLeftAtHead = (key === -1) && direction === 'left';
    const slideRightAtTail = (key === this.slides.length) && direction === 'right';
    const doSlideAfterSkip = (flag, slideFn) => {
      if (flag) {
        setTimeout(() => slideFn.call(this), 0);
      }
    };
    doSlideAfterSkip(slideLeftAtHead, this.onSlideLeft);
    doSlideAfterSkip(slideRightAtTail, this.onSlideRight);
  }

  stopFunction(timeoutID) {
    console.log('stopFunction');
    clearTimeout(timeoutID);
  }

  bindHanlders(handlers) {
    handlers.forEach((handler) => {
      this[handler] = this[handler].bind(this);
    });
  }

  onSlideLeft() {
    const key = this.state.key === -1 ?
      this.slides.length - 1 :
      this.state.key - 1;

    this.setState({
      key,
      direction: 'left',
    });
  }

  onSlideRight() {
    // console.log('onSlideRight');
    const key = this.state.key === this.slides.length ?
      0 : this.state.key + 1;

    this.setState({
      key,
      direction: 'right',
    });
  }

  onDotsClick(index) {
    const key = parseInt(index, 10);
    if (key >= 0 &&
      key !== this.state.key &&
      key < this.slides.length) {
      const direction = key > this.state.key ? 'right' : 'left';
      this.setState({
        key,
        direction,
      });
    }
  }

  onSwipe(evt) {
    const direction = evt.direction.toLowerCase();
    switch (direction) {
      case 'left': {
        this.onSlideRight();
        break;
      }
      case 'right': {
        this.onSlideLeft();
        break;
      }
      default:
        break;
    }
  }

  getActiveDot() {
    switch (this.state.key) {
      case -1:
        return this.slides.length - 1;
      case this.slides.length:
        return 0;
      default:
        return this.state.key;
    }
  }

  getStyle() {
    return {
      container: {
        overflow: 'hidden',
        position: 'relative',
        width: this.width,
        height: this.height,
        minWidth: 960,
      },
      wrapper: {
        display: 'flex',
        transitionDuration: this.duration,
        transform: `translateX(${100 * -(this.state.key + 1)}%)`,
      },
    };
  }

  render() {
    const {
      arrowLeft: ArrowLeft,
      arrowRight: ArrowRight,
      dots: Dots,
    } = this.props;

    const style = this.getStyle();
    const activeDot = this.getActiveDot();
    return (
      <div
        className="react-infinite-slides container"
        style={style.container}
        ref={(c) => { this.container = c; }}
      >
        {
          ArrowLeft ?
            <ArrowLeft onClick={() => {
              console.log('ArrowLeft', this.timeoutID, this.autoTimeoutID);
              this.stopFunction(this.timeoutID);
              this.stopFunction(this.autoTimeoutID);
              return this.onSlideLeft();
            }} /> : null
        }
        {
          ArrowRight ?
            <ArrowRight onClick={() => {
              console.log('ArrowRight', this.timeoutID, this.autoTimeoutID);
              this.stopFunction(this.timeoutID);
              this.stopFunction(this.autoTimeoutID);
              return this.onSlideRight();
            }} /> : null
        }
        {
          Dots ?
            <Dots
              activeDot={activeDot}
              length={this.slides.length}
              onDotsClick={this.onDotsClick}
              onClick={this.onDotsClick}
            /> : null
        }
        <div
          className="react-infinite-slides wrapper"
          style={style.wrapper}
        >
          {this.head}
          {this.slides}
          {this.tail}
        </div>
      </div>
    );
  }
}

Slides.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  width: PropTypes.string,
  height: PropTypes.string,
  delay: PropTypes.number,
  duration: PropTypes.number,
  autoplay: PropTypes.bool,
};
